import React, { useRef } from 'react'
import { useSelector } from 'react-redux';
import ActivityList from '../../../components/Multi/Department-Activity/ActivityList';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import CreateButton from '../../../components/Tools/CreateButton';

const ActivityListPage = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
              <div className="row" style={{ padding: "10px 16px" }}>
                  <div className="col-md-6">
                      <h4 style={{ color: "#28326f", margin:0}}>Activities</h4>
                      <CustomBreadcrumbs linksArray={[]} title="Activities"/>
                  </div>
                  <div className="col-md-6"></div>
              </div>
              <ActivityList/>
            </div>
            {
              (authData.user.user_type === 'l1' && authData.user.department_details.department_level === 'T1') && <CreateButton title={"Add Activity"} url={"/department/add-activity"}/>
            }
            
        </div>
    )
}

export default ActivityListPage
